var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detail-header',{attrs:{"title":'Librarian Dashboard'}}),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row container"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"card d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"text-xl"},[_vm._v("42")]),_vm._v(" "),_c('div',[_vm._v("Total Paid Usage this Month")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"card d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"text-xl"},[_vm._v("42")]),_vm._v(" "),_c('div',[_vm._v("Total Views this Month")])])])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/views/dashboard/DashboardLibrarian.vue